'use strict';

approvalSetupController.$inject = ['$scope', '$location', 'dialogHelper'];

angular.module('schoolLinqApp').controller('approvalSetupController', approvalSetupController);

function approvalSetupController($scope, $location, dialogHelper) {
	$scope.setAngular11Form = function (event) {
		$scope.angular11Form = event;
	};

	$scope.vm = getViewModel();

	function getViewModel() {
		const poApproval = 'poApproval';
		const hcmApproval = 'hcmApproval';

		var model = {
			filter: {
				tab: poApproval,
			},
		};

		function changeTab(model, tab) {
			model.filter.tab = tab;
		}

		function formIsDirty() {
			return $scope.angular11Form && $scope.angular11Form.dirty;
		}

		return angular.extend(model, {
			formIsDirty: formIsDirty,
			changeTab: _.partial(changeTab, model),
		});
	}

	var onRouteChangeOff = $scope.$on('$locationChangeStart', _.partial(dialogHelper.routeChange, $scope.vm.formIsDirty, acceptFunction));

	function acceptFunction() {
		onRouteChangeOff(); //Stop listening for location changes
		return angular.noop;
	}
}
